import React from "react";
import { ToggleButtonGroup, ToggleButton, Box } from '@mui/material';


const NestlingRadioDevice = ({ value, onChange, styleToggle, disablePrism, disableTitan, disableCaesar, disableV1}) => {

  return (
    <>
    <Box sx={{ fontSize: '15px', color:"#406599", pt:'25px'}}>
          CFX devices
    </Box>
    <Box>
        <ToggleButtonGroup
          color="error"
          size="small"
          value={value}
          exclusive
          onChange={onChange}
          style={styleToggle}
        >
          <ToggleButton value="Prism" color="info" disabled={disablePrism}>Prism</ToggleButton>
          <ToggleButton value="Titan" color="info" disabled={disableTitan}>Titan</ToggleButton>
          <ToggleButton value="Caesar" color="info" disabled={disableCaesar}>Caesar</ToggleButton>
          <ToggleButton value="V1" color="info" disabled={disableV1}>V1</ToggleButton>
        </ToggleButtonGroup>
    </Box>
    </>
  );
};

export default NestlingRadioDevice;
